import React from 'react';
import { BarChart2, Compass, LineChart, Activity, Target } from 'lucide-react';
const FeaturesSection = () => {
  const features = [{
    icon: <BarChart2 className="w-6 h-6 text-[#1649ff]" data-id="element-555" data-mp="1c4yuzv8pt8tt" />,
    title: 'Score por Marca',
    description: 'Visualize a pontuação média de cada marca com base nos atributos analisados, comparando diretamente com seus concorrentes.'
  }, {
    icon: <Compass className="w-6 h-6 text-[#1649ff]" data-id="element-556" data-mp="1zrym8hyab6j2" />,
    title: 'Radar Comparativo',
    description: 'Compare visualmente os atributos da sua marca em relação aos concorrentes através de um gráfico radar interativo e detalhado.'
  }, {
    icon: <Target className="w-6 h-6 text-[#1649ff]" data-id="element-557" data-mp="29ojq2zykiblb" />,
    title: 'Top Marcas por Atributo',
    description: 'Identifique as cinco marcas com melhor desempenho em cada atributo, descobrindo onde sua marca se destaca ou precisa melhorar.'
  }, {
    icon: <Activity className="w-6 h-6 text-[#1649ff]" data-id="element-558" data-mp="afd1t6aeprse" />,
    title: 'Heatmap de Scores',
    description: 'Visualize em detalhes as pontuações de cada marca em todos os atributos analisados através de um mapa de calor intuitivo.'
  }];
  return <section className="py-16 bg-white" data-id="element-559" data-mp="38bvj4558l0lj">
      <div className="container px-4 mx-auto sm:px-6 lg:px-8" data-id="element-560" data-mp="38b3ujea2434r">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-561" data-mp="3d3df0esekazn">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-562" data-mp="3i26weiat8m53">
            Análise semântica completa da sua marca
          </h2>
          <p className="mt-4 text-lg text-gray-600" data-id="element-563" data-mp="3n08dwysl8deg">
            Nosso relatório oferece visualizações detalhadas e insights
            acionáveis para otimizar a presença da sua marca nas respostas de
            IAs generativas.
          </p>
        </div>
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-2" data-id="element-564" data-mp="1xmd0vdgmmioj">
          {features.map((feature, index) => <div key={index} className="p-6 bg-white border border-gray-100 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-565" data-mp="21nowq0q3g056" data-mpi={index}>
              <div className="w-12 h-12 mb-4 flex items-center justify-center bg-blue-50 rounded-lg" data-id="element-566" data-mp="350p4n2rketem">
                {feature.icon}
              </div>
              <h3 className="mb-2 text-xl font-semibold text-gray-900" data-id="element-567" data-mp="3e0lrcyue9i71">
                {feature.title}
              </h3>
              <p className="text-gray-600" data-id="element-568" data-mp="39wnnkau4jj7n">{feature.description}</p>
            </div>)}
        </div>
      </div>
      {/* AI-themed decorative elements */}
      <div className="relative mt-16 overflow-hidden" data-id="element-569" data-mp="3izf06dyqkl0v">
        <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#1649ff] to-transparent opacity-20" data-id="element-570" data-mp="3iwsukjveofla"></div>
        <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 w-16 h-16 bg-blue-50 rounded-full" data-id="element-571" data-mp="3so6qkho5ex9o"></div>
        <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-[#1649ff] rounded-full opacity-20" data-id="element-572" data-mp="ajlj9y0ht7ja"></div>
      </div>
    </section>;
};
export default FeaturesSection;